export function rgbToHex({ red = 0, green = 0, blue = 0 } = {}) {
  const redHex = red < 16 ? `0${red.toString(16)}` : red.toString(16)
  const greenHex = green < 16 ? `0${green.toString(16)}` : green.toString(16)
  const blueHex = blue < 16 ? `0${blue.toString(16)}` : blue.toString(16)

  return `#${redHex}${greenHex}${blueHex}`
}

export function hexToRGB(
  hex?: string
): { red: number; green: number; blue: number } | null {
  if (!hex || hex[0] !== '#') return null

  const redHex = hex.slice(1, 3)
  const greenHex = hex.slice(3, 5)
  const blueHex = hex.slice(5, 7)

  const [red, green, blue] = [redHex, greenHex, blueHex].map((hex) =>
    Number(`0x${hex}`)
  )

  return { red, green, blue }
}
